import useGrantAccess from 'modules/access-controls/hooks/use-grant-access';
import {AccessControlProps} from 'modules/access-controls/types';
import React from 'react';
import {ClipLoader} from 'react-spinners';
import styled from 'styled-components';
import logo from 'shared/assets/images/logo.png';

const AccessControl: React.FC<AccessControlProps> = ({
  cityId,
  companyId,
  city,
  company,
  isFranchiseAccessControl,
  permissionGroup,
}) => {
  const {mutate, isLoading} = useGrantAccess();

  return (
    <Container
      onClick={() => mutate({companyId, cityId, isFranchiseAccessControl})}>
      {isFranchiseAccessControl && (
        <LogoBox>
          <LogoImage src={logo} />
        </LogoBox>
      )}
      {company && <Image src={company.logo} />}
      {city && <Circle>{city.name[0].toUpperCase()}</Circle>}
      <Info>
        <Title>{city?.name ?? company?.name ?? permissionGroup.name}</Title>
        <Description>
          {city?.state ?? company?.email ?? 'Gerênciar franquia'}
        </Description>
      </Info>
      {isLoading && <Spinner />}
    </Container>
  );
};

export default AccessControl;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
`;

const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 25px;
`;

const LogoBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 5px;
  border-radius: 25px;
  background-color: ${(props) => props.theme.colors.background};
`;

const LogoImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

const Circle = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 25px;
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

const Title = styled.h1`
  color: ${(props) => props.theme.colors.text};
`;

const Description = styled.p`
  margin-top: -3px;
  color: ${(props) => props.theme.colors.text};
`;

const Spinner = styled(ClipLoader).attrs((props) => ({
  size: 18,
  color: props.theme.colors.primary,
}))``;
